// extracted by mini-css-extract-plugin
module.exports = {"title":"feedback_title__vLWV9","text":"feedback_text__bK_f3","button":"feedback_button__fN7P_"};